import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import ListTick from 'components/Icons/tick-list';
import { noop } from 'lodash';
import {
  FocusableActionsWrapper,
  StyledButtonWrapper,
  StyledButton,
  StyledButtonText,
  StyledInputWrapper,
  StyledInput,
  StyledInputCursor,
  StyledInputText,
  StyledInputInvalidMessage,
} from './StyledComponents';

const ActionsSection = (props) => <FocusableActionsWrapper {...props} />;

ActionsSection.Button = ({ onEnter, onFocus, label, focusOnMouseEnter, selected, type }) => {
  let styledButton = (
    <Button onEnter={onEnter} onFocus={onFocus} focusOnMouseEnter={focusOnMouseEnter}>
      <StyledButtonText>{label}</StyledButtonText>
    </Button>
  );
  if (type === 'tick-button') {
    styledButton = (
      <StyledButton
        onEnter={onEnter}
        onFocus={onFocus}
        focusOnMouseEnter={focusOnMouseEnter}
        selected={selected}
      >
        <StyledButtonText>
          {label} <ListTick />
        </StyledButtonText>
      </StyledButton>
    );
  }

  return <StyledButtonWrapper>{styledButton}</StyledButtonWrapper>;
};

ActionsSection.Button.defaultProps = {
  focusOnMouseEnter: true,
};

ActionsSection.Button.propTypes = {
  onEnter: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  focusOnMouseEnter: PropTypes.bool,
  selected: PropTypes.bool,
  type: PropTypes.string,
};

ActionsSection.Input = ({
  onEnter,
  onFocus,
  value,
  placeholder,
  isValid,
  invalidMessage,
  cursor,
  cursorPosition,
  renderCharacter,
}) => {
  let valueComponent;
  const cursorComponent = <StyledInputCursor key="cursor" />;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const preparedValue = useMemo(
    () => (renderCharacter ? [...value].map(renderCharacter) : value),
    [renderCharacter, value],
  );

  if (cursor && value) {
    const valueWithCursorArray = [
      ...preparedValue.slice(0, cursorPosition),
      cursorComponent,
      ...preparedValue.slice(cursorPosition),
    ];
    valueComponent = <StyledInputText isActive>{valueWithCursorArray}</StyledInputText>;
  } else {
    valueComponent = (
      <StyledInputText>
        {cursor && cursorComponent}
        {preparedValue || placeholder}
      </StyledInputText>
    );
  }
  return (
    <StyledInputWrapper>
      <StyledInput onEnter={onEnter} onFocus={onFocus} isValid={isValid}>
        {valueComponent}
      </StyledInput>
      {!isValid && <StyledInputInvalidMessage>{invalidMessage}</StyledInputInvalidMessage>}
    </StyledInputWrapper>
  );
};

ActionsSection.Input.propTypes = {
  onEnter: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  isValid: PropTypes.bool,
  invalidMessage: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  cursor: PropTypes.bool,
  cursorPosition: PropTypes.number,
  renderCharacter: PropTypes.func,
};

ActionsSection.Input.defaultProps = {
  isValid: true,
  cursor: false,
  cursorPosition: 0,
  onFocus: noop,
};

export default ActionsSection;
